import React from 'react';

import Modal from 'common/components/modals/Modal';
import PropTypes from '../../propTypes';

import DobWarningModalContent from './DobWarningModalContent';

class DobWarningModal extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    age: PropTypes.number,
  };

  static defaultProps = {
    isOpen: false,
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        bodyClassName="ConfirmationModal__body"
        className="ConfirmationModal"
        onRequestClose={this.props.onClose}
      >
        <DobWarningModalContent
          onClose={this.props.onClose}
          age={this.props.age}
        />
      </Modal>
    );
  }
}

export default DobWarningModal;
